module.exports = __webpack_public_path__ + "img/about.045226b5.svg";